import { render } from "./vue-tel-input.vue?vue&type=template&id=14158b1a"
import script from "./vue-tel-input.vue?vue&type=script&lang=js"
export * from "./vue-tel-input.vue?vue&type=script&lang=js"

import "../assets/sprite.css?vue&type=style&index=0&lang=css"
import "../assets/component.css?vue&type=style&index=1&lang=css"
script.render = render

export default script